import { CharacterCompass } from '@edwin-group/cj-graphql';

const RESPECT_ORDER = [
  'Resilience',
  'Empathy',
  'Self-awareness',
  'Passion',
  'Excellence',
  'Communication',
  'Teamwork',
] as const;

const normalize = (s?: string | null) => (s ?? '').toLowerCase().replace(/[^\p{L}]+/gu, '');

const rankMap = new Map<string, number>(RESPECT_ORDER.map((t, i) => [normalize(t), i]));
rankMap.set('positivity', rankMap.get('passion')!);

export function sortCharacterCompass(list: CharacterCompass[] = []) {
  return [...list].sort((a, b) => {
    const ai = rankMap.get(normalize(a.attributes?.trait)) ?? Number.MAX_SAFE_INTEGER;
    const bi = rankMap.get(normalize(b.attributes?.trait)) ?? Number.MAX_SAFE_INTEGER;

    if (ai !== bi) return ai - bi;

    const aid = Number(a.id ?? Infinity);
    const bid = Number(b.id ?? Infinity);
    return aid - bid;
  });
}
